// extracted by mini-css-extract-plugin
module.exports = {"bg":"PanelModal_bg__2oEnt","panel":"PanelModal_panel__3QIyG","closeButton":"PanelModal_closeButton__2GGyA"};